import React, { Component } from "react";
import { Nav, Tab } from "react-bootstrap";
import { MdClose } from "react-icons/md";
import InfiniteScroll from "react-infinite-scroll-component";
import ManagementNavBottom from "../blocks/ManagementNavBottom";
import Spinner from "../../../base/features/micro/Spinner";
import Empty from "../../../base/features/blocks/Empty";
import OrderBlock from "../../../base/features/blocks/OrderBlock";
import { getShopOrders } from "./services";

class ManagementOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openOrders: null,
      closedOrders: null,
      defaultActiveKey: "open",
      openOrdersSearchKey: "",
      closedOrdersSearchKey: "",
      hasMoreOpenOrders: false,
      nextOpenOrders: "",
      hasMoreClosedOrders: false,
      nextClosedOrders: "",
      shopUid: window.location.pathname.split("/")[2],
    };
  }
  componentDidMount() {
    this.getOpenOrders();
    this.getClosedOrders();
  }
  getOpenOrders() {
    let q = this.state.openOrdersSearchKey;
    getShopOrders(this.state.shopUid, false, null, q).then((items) => {
      if (q === this.state.openOrdersSearchKey && items) {
        this.setState({
          openOrders: items.results,
          hasMoreOpenOrders: items.next ? true : false,
          nextOpenOrders: items.next,
        });
      }
    });
  }
  getClosedOrders() {
    let q = this.state.closedOrdersSearchKey;
    getShopOrders(this.state.shopUid, true, null, q).then((items) => {
      if (q === this.state.closedOrdersSearchKey && items) {
        this.setState({
          closedOrders: items.results,
          hasMoreClosedOrders: items.next ? true : false,
          nextClosedOrders: items.next,
        });
      }
    });
  }
  fetchMoreOpenOrders() {
    getShopOrders(this.state.shopUid, false, this.state.nextOpenOrders).then(
      (items) => {
        if (items) {
          var newOrders = this.state.openOrders;
          newOrders = newOrders.concat(items.results);

          this.setState({
            openOrders: newOrders,
            nextOpenOrders: items.next,
            hasMoreOpenOrders: items.next ? true : false,
          });
        }
      }
    );
  }
  fetchMoreClosedOrders() {
    getShopOrders(this.state.shopUid, true, this.state.nextOpenOrders).then(
      (items) => {
        if (items) {
          let newOrders = this.state.closedOrders;
          newOrders = newOrders.concat(items.results);

          this.setState({
            closedOrders: newOrders,
            nextClosedOrders: items.next,
            hasMoreClosedOrders: items.next ? true : false,
          });
        }
      }
    );
  }
  render() {
    return (
      <div className="container-fluid px-0" style={{ marginBottom: "80px" }}>
        <Tab.Container
          className="border-0 w-100"
          activeKey={this.state.defaultActiveKey}
          onSelect={(i) => this.setState({ defaultActiveKey: i })}
          defaultActiveKey={this.state.defaultActiveKey}
          id="tab-example4"
        >
          <div
            className="row mx-0 bg-white position-fixed shadow-sm"
            style={{ top: "0", left: "0", right: "0", zIndex: "9999999" }}
          >
            <div className="col-12 px-4 py-2-3">
              <h1 className="fw-bold fs-4 mb-0">سفارشات</h1>
            </div>
            <div className="col-2 px-0" />

            <div className="col-4 text-center px-0">
              <Nav.Link
                className={
                  "p-3 fw-bolder fs-6 " +
                  (this.state.defaultActiveKey === "open"
                    ? "border-main border-3 color-main border-top-0 border-start-0 border-end-0"
                    : "text-muted")
                }
                eventKey="open"
              >
                در حال پردازش
              </Nav.Link>
            </div>

            <div className="col-4 text-center px-0">
              <Nav.Link
                className={
                  "p-3 fw-bolder fs-6 " +
                  (this.state.defaultActiveKey === "closed"
                    ? "border-main border-3 color-main border-top-0 border-start-0 border-end-0"
                    : "text-muted")
                }
                eventKey="closed"
              >
                بسته شده
              </Nav.Link>
            </div>
            <div className="col-2 px-0" />
          </div>

          <div className="row mx-0" style={{ marginTop: "110px" }}>
            <div className="col-12 px-0">
              <Tab.Content>
                <Tab.Pane eventKey="open">
                  {this.state.openOrders ? (
                    <section>
                      <div className="row mx-0">
                        <div className="col-12 px-4 py-3 text-center position-relative">
                          <input
                            type="text"
                            value={this.state.openOrdersSearchKey}
                            onChange={(e) =>
                              this.setState(
                                { openOrdersSearchKey: e.target.value },
                                () => {
                                  this.getOpenOrders();
                                }
                              )
                            }
                            className="form-control px-3 py-2 rounded14 w-100"
                            style={{ height: "44px" }}
                            placeholder="جستجو کنید"
                          />
                          {this.state.openOrdersSearchKey.length !== 0 && (
                            <MdClose
                              size={26}
                              style={{ left: "32px", top: "0", bottom: "0" }}
                              className="position-absolute my-auto"
                              onClick={() =>
                                this.setState(
                                  { openOrdersSearchKey: "" },
                                  () => {
                                    this.getOpenOrders();
                                  }
                                )
                              }
                            />
                          )}
                        </div>
                      </div>
                      <InfiniteScroll
                        dataLength={this.state.openOrders.length}
                        next={() => this.fetchMoreOpenOrders()}
                        hasMore={this.state.hasMoreOpenOrders}
                        className="row mx-0 px-4"
                        loader={<Spinner />}
                      >
                        {this.state.openOrders.length === 0 && (
                          <Empty text={"سفارشی یافت نشد."} />
                        )}
                        {this.state.openOrders.map((order, o) => (
                          <OrderBlock order={order} />
                        ))}
                      </InfiniteScroll>
                    </section>
                  ) : (
                    <Spinner />
                  )}
                </Tab.Pane>
                <Tab.Pane eventKey="closed">
                  {this.state.closedOrders ? (
                    <section>
                      <div className="row mx-0">
                        <div className="col-12 px-4 py-3 text-center position-relative">
                          <input
                            type="text"
                            value={this.state.closedOrdersSearchKey}
                            onChange={(e) =>
                              this.setState(
                                { closedOrdersSearchKey: e.target.value },
                                () => {
                                  this.getClosedOrders();
                                }
                              )
                            }
                            className="form-control px-3 py-2 rounded14 w-100"
                            style={{ height: "44px" }}
                            placeholder="جستجو کنید"
                          />
                          {this.state.closedOrdersSearchKey.length !== 0 && (
                            <MdClose
                              size={26}
                              style={{ left: "32px", top: "0", bottom: "0" }}
                              className="position-absolute my-auto"
                              onClick={() =>
                                this.setState(
                                  { closedOrdersSearchKey: "" },
                                  () => {
                                    this.getClosedOrders();
                                  }
                                )
                              }
                            />
                          )}
                        </div>
                      </div>
                      <InfiniteScroll
                        dataLength={this.state.closedOrders.length}
                        next={() => this.fetchMoreClosedOrders()}
                        hasMore={this.state.hasMoreClosedOrders}
                        className="row mx-0 px-4"
                        loader={<Spinner />}
                      >
                        {this.state.closedOrders.length === 0 ? (
                          <Empty text={"سفارشی یافت نشد."} />
                        ) : (
                          this.state.closedOrders.map((order, o) => (
                            <OrderBlock order={order} />
                          ))
                        )}
                      </InfiniteScroll>
                    </section>
                  ) : (
                    <Spinner />
                  )}
                </Tab.Pane>
              </Tab.Content>
            </div>
          </div>
        </Tab.Container>
        <ManagementNavBottom />
      </div>
    );
  }
}

export default ManagementOrders;
